import { createI18n } from 'vue-i18n'
import es from './locales/es.json'
import en from './locales/en.json'
import zh from './locales/zh.json'
import ja from './locales/ja.json'
import fr from './locales/fr.json'
import pt from './locales/pt.json'

const i18n = createI18n({
  legacy: false,
  locale: 'es',
  fallbackLocale: 'es',
  messages: {
    es,
    en,
    zh,
    ja,
    fr,
    pt
  }
})

export default i18n
